import { types } from 'mobx-state-tree';
import currencies from '../../constants/currency.json';

const PricingRange = types
  .model('PricingRange', {
    breakEven: types.maybe(types.number),
    profit: types.maybe(types.number),
    currency: types.string,
    inPercents: types.boolean,
    maxValue: types.number,
    minValue: types.number,
    initialState: types.optional(types.frozen, {}),
  })
  .views(self => ({
    get isChanged() {
      return (
        self.breakEven !== self.initialState.breakEven ||
        self.profit !== self.initialState.profit ||
        self.inPercents !== self.initialState.inPercents
      );
    },
    get formattedProfit() {
      return self.inPercents
        ? `${self.profit}%`
        : `${currencies[self.currency].symbol}${self.profit}`;
    },
    get formattedBreakEven() {
      return self.inPercents
        ? `${self.breakEven}%`
        : `${currencies[self.currency].symbol}${self.breakEven}`;
    },
  }))
  .actions(self => ({
    afterCreate() {
      const { breakEven, currency, inPercents, maxValue, minValue, profit } = self;
      self.initialState = {
        breakEven,
        currency,
        inPercents,
        maxValue,
        minValue,
        profit,
      };
    },
    setBreakEven(val) {
      self.breakEven = val;
    },
    setProfit(val) {
      self.profit = val;
    },
    setInPercents(val) {
      self.inPercents = val;
    },
    resetValues() {
      const { breakEven, currency, inPercents, maxValue, minValue, profit } = self.initialState;
      self.breakEven = breakEven;
      self.currency = currency;
      self.inPercents = inPercents;
      self.maxValue = maxValue;
      self.minValue = minValue;
      self.profit = profit;
    },
  }));

export default PricingRange;
